import React from 'react';

export default function Login() {
  return (<a href="/signin">Sign in with Google</a>);
}



// WEBPACK FOOTER //
// ./client/Login.js